import UserInfo from "components/cards/UserInfo";
import StatusBadge from "components/general/StatusBadge";
import IMPORTANT_VARS from "constants/ImportantVars";
import {
  useGetStaffRequestQuery,
  useGetStaffTransferRequestsQuery,
} from "apis/services/requests";
import { useSearchParams } from "react-router-dom";
import SecondaryPageHeader from "components/general/SecondaryPageHeader";
import Table from "components/general/Table";
import moment from "moment";
import styles from "./styles.module.scss";

export default function IntegrationTransfer() {
  const [searchParams] = useSearchParams();

  const { data, isFetching: isStaffLoading } = useGetStaffRequestQuery({
    page: Number(searchParams.get("page") ?? "1"),
    search: searchParams.get("search") || undefined,
    status: "1",
    start_date: searchParams.get("startDate") || undefined,
    end_date: searchParams.get("endDate") || undefined,
    page_size: IMPORTANT_VARS.TabelDataPageSize,
    request_type: "1", // transfer
  });
  const changeStaffData = (item: any): any => ({
    id: String(item.id),
    rowData: [
      {
        type: "element",
        dataItem: <UserInfo data={item.created_for} isTableCol />,
      },
      {
        type: "text",
        dataItem: String(moment(item?.start_date).format("DD-MM-YYYY")),
      },
      {
        type: "text",
        dataItem: String(item?.id),
      },
      {
        type: "text",
        dataItem: String(item?.project),
      },
      {
        type: "text",
        dataItem: item?.category_name || "--",
      },
      {
        type: "text",
        dataItem: `${item?.allocations}%`,
      },
      {
        type: "element",
        dataItem: (
          <StatusBadge
            text={item?.status}
            color={item?.status === "accepted" ? "success" : "warning"}
            containerStyle={styles.statusBadge}
          />
        ),
      },
      {
        type: "text",
        dataItem: (
          <StatusBadge
            iconType={item?.is_synced ? "success" : "fail"}
            color={item?.is_synced ? "success" : "warning"}
          />
        ),
      },
    ],
  });
  return (
    <>
      <SecondaryPageHeader title="Transfers" />

      <Table
        isCheckBoxVisible={false}
        showSearchFilter
        isLoading={isStaffLoading}
        headers={[
          "Members ID",
          "Date",
          "Request ID",
          "Project ID",
          "Category",
          "Percentage",
          "Status",
          "Is Synced",
        ]}
        data={data?.results.map((item) => changeStaffData(item)) ?? []}
        count={data?.count}
        pageSize={IMPORTANT_VARS.TabelDataPageSize}
      />
    </>
  );
}
